import {Priority, UpdateUserCommand} from "../api/user.ts";
import {FC, useState} from "react";
import {Column, Row} from "../atoms/Layout.tsx";
import InputGroup from "../molecules/InputGroup.tsx";
import SelectInputGroup from "../molecules/SelectInputGroup.tsx";
import {Option} from "../atoms/SelectInput.tsx";
import Button from "../atoms/Button.tsx";

interface Props {
    onSubmit: (data: UpdateUserCommand) => void;
}

const NOTIFICATION_PREFERENCES: Option[] = [
    { "label": "No notifications", value: "none" },
    { "label": "All Issues", "value": Priority.LOW },
    { "label": "Medium-Priority and above", "value": Priority.MEDIUM },
    { "label": "High-Priority and above", "value": Priority.HIGH },
    { "label": "Critical-Priority only", "value": Priority.CRITICAL },
]

const validateName = (attemptedSubmit: boolean, name: string): string | undefined => {
    if (!name) {
        if (!attemptedSubmit) {
            return undefined;
        }
        return "Please enter your name";
    }
    if (name.length > 255) {
        return "Name must be less than 255 characters";
    }
    return undefined;
}

const UserSettingsForm: FC<Props> = ({onSubmit}) => {
    const [attemptedSubmit, setAttemptedSubmit] = useState(false);
    const [name, setName] = useState('');
    const [notificationPreferences, setNotificationPreferences] = useState<string>("weekly");

    const handleSubmit = () => {
        if (validateName(true, name)) {
            setAttemptedSubmit(true);
            return;
        }

        let notificationForPriority = undefined;
        if (notificationPreferences !== "none") {
            notificationForPriority = notificationPreferences as Priority;
        }
        onSubmit({ name, notificationForPriority });
    }

    return <Column gap="20">
        <InputGroup label="What's your name?" value={name} onChange={setName} error={attemptedSubmit ? validateName(attemptedSubmit, name) : undefined} />
        <SelectInputGroup label="Notification Preferences" value={notificationPreferences} onChange={setNotificationPreferences} options={NOTIFICATION_PREFERENCES} error={attemptedSubmit && !notificationPreferences ? "Please select your notification preferences" : undefined} />
        <Row>
            <Button onClick={handleSubmit}>Continue</Button>
        </Row>
    </Column>
}

export default UserSettingsForm;